/**
 * "192.168.1.10:8008" のようなポート付きIPアドレスからポートを除いて返す
 * @param {string} ipAddress
 * @returns {string}
 */
export function removePortFromIpAddress(ipAddress) {
  return ipAddress.split(':')[0].trim()
}
